// Plafonds MaPrimeRénov' hors Île-de-France & Outre-mer au 1er janvier 2026 (RFR en €)
const BASE = {
  1: [17363, 22259, 31185],
  2: [25393, 32553, 45842],
  3: [30540, 39148, 55196],
  4: [35676, 45735, 64550],
  5: [40835, 52348, 73907],
};
const EXTRA = [5151, 6598, 9357];
export const BRACKETS = ["Très modestes", "Modestes", "Intermédiaires", "Supérieurs"];

export const thresholdsFor = (householdSize) => {
  const n = Math.max(1, parseInt(householdSize, 10) || 1);
  if (n <= 5) return BASE[n];
  return BASE[5].map((v, i) => v + EXTRA[i] * (n - 5));
};

export const classifyIncome = (rfr, householdSize) => {
  if (rfr === "" || rfr === null || rfr === undefined || !householdSize) return "";
  const value = Number(rfr);
  if (Number.isNaN(value) || value < 0) return "";
  const [tm, m, inter] = thresholdsFor(householdSize);
  if (value <= tm) return BRACKETS[0];
  if (value <= m) return BRACKETS[1];
  if (value <= inter) return BRACKETS[2];
  return BRACKETS[3];
};

export const formatEuro = (n) => Number(n).toLocaleString("fr-FR");
